import {
  SHOW_SETTING,
  SHOW_MANAGE,
  SHOW_MAP_LAYER,
  SHOW_CHART,
  SHOW_MENU,
  SHOW_MENU_POPUP,
  RESET_LAYER_ALL
} from "../actions/type";

const initialState = {
  isShowSetting: false,
  isShowManage: false,
  isShowMapLayer: false,
  isShowChart: false,
  isShowMenu: false,
  isShowMenuPopup: false,
  isResetLayer: false,
};

const menuReducers = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SETTING: {
      return {
        ...state,
        isShowSetting: action.payload,
      };
    }

    case SHOW_MANAGE: {
      return {
        ...state,
        isShowManage: action.payload,
      };
    }

    case SHOW_CHART: {
      return {
        ...state,
        isShowChart: action.payload,
      };
    }

    case SHOW_MAP_LAYER: {
      return {
        ...state,
        isShowMapLayer: action.payload,
      };
    }

    case SHOW_MENU: {
      return {
        ...state,
        isShowMenu: action.payload,
      };
    }

    case SHOW_MENU_POPUP: {
      return {
        ...state,
        isShowMenuPopup: action.payload,
      };
    }

    case RESET_LAYER_ALL: {
      return {
        ...state,
        isResetLayer: !state.isResetLayer,
      };
    }

    default:
      return state;
  }
};

export default menuReducers;
